import React, { MouseEventHandler } from 'react';
import { ButtonRowView } from '../../Buttons/ButtonRowView';

type TTakePhotoProps = {
    /** Design version of the profile widget (`TWidget.version`). */
    version: number | undefined;
    label?: string;
    iconName?: string;
    handleClick: MouseEventHandler;
};
const TakePhoto = ({ version, label, iconName, handleClick }: TTakePhotoProps) => {
    return <ButtonRowView version={version} label={label} iconName={iconName} onClick={handleClick} />;
};
export { TakePhoto };
